<template>
  <div class="couponBanner">
    <div class="couponBannerBox">
      <div
        class="cssBanner"
        :style="{
          background: '#60C8E4 url(' + cssBannerStyle.url + ') no-repeat',
          backgroundSize: 'cover',
        }"
      >
        <div class="mainContainer">
          <div class="row">
            <div class="coupon_rightContentBox col-12 order-sm-12 col-sm-8">
              <div class="coupon_swiperBox">
                <splide
                  :options="options"
                  ref="splideBox"
                  :slides="couponBanners"
                  @splide:moved="moved"
                >
                  <splide-slide
                    class="ppppppp"
                    v-for="couponBanner in couponBanners"
                    :key="couponBanner.couponPromotionBannerUrl"
                  >
                    <img
                      :src="couponBanner.couponPromotionBannerUrl"
                      @click="hanldeCouponDetail(couponBanner.couponId)"
                      class="img-fluid"
                      alt="slide.alt"
                    />
                  </splide-slide>
                  <!-- <splide-slide class="ppppppp">
                    <img
                      src="@/assets/images/banner_test.jpg"
                      class="img-fluid"
                      alt="slide.alt"
                    />
                  </splide-slide> -->
                </splide>
              </div>
            </div>
            <div class="coupon_leftContentBox col-12 order-sm-1 col-sm-4">
              <div class="block">
                <div class="coupon_leftContentBox_mainTitle">
                  <span class="coupon_leftContentBox_title">Rabbitzhop 精選著數:</span>
                  <!--span class="coupon_leftContentBox_text">{{
                    couponBanner.couponName
                  }}</span-->
                  <span class="coupon_leftContentBox_text">{{
                    couponBanner.shortDescription
                  }}</span>
                </div>

                <div class="couponBoxVerbar"></div>
                <div class="coupon-promotion-info row">
                  <div class="coupon_leftContentBox_subtitle col-8 col-sm-12">
                    <div v-show="couponBanner.couponType === 'Percentage Off'">
                      <span class="couponBox_percentage">
                        {{ parseInt(couponBanner.amount) }}
                      </span>
                      <div class="couponBox_smallText">
                        <span>{{ couponBanner.symbol }}</span>
                        <span>Purchasing Offer</span>
                      </div>
                    </div>
                    <div v-show="couponBanner.couponType === 'Fixed Amount'">
                      <span class="couponBox_smallText">{{
                        couponBanner.symbol
                      }}</span>
                      <span class="couponBox_percentage">{{
                        couponBanner.amount
                      }}</span>
                      <div class="couponBox_smallText">
                        <span>Purchasing Offer</span>
                      </div>
                    </div>
                    <div v-show="couponBanner.couponType === 'Amount Off'">
                      <span class="couponBox_smallText">{{
                        couponBanner.symbol
                      }}</span>
                      <span class="couponBox_percentage">{{
                        parseFloat(parseFloat(couponBanner.amount).toFixed(2))
                      }}</span>
                      <div class="couponBox_smallText">
                        <span>off</span>
                        <span>Purchasing Offer</span>
                      </div>
                    </div>
                    <div
                      class="col-12"
                      style="padding:0;"
                    >
                      <button
                        v-if="parseFloat(couponBanner.price) === 0"
                        class="coupon_redeem_button"
                        @click="hanldeCouponDetail(couponBanner.couponId)"
                      >
                        <i class="icon"><img src="@/assets/images/icon-heart.svg" /></i>Download
                      </button>
                      <button
                        v-else
                        class="coupon_redeem_button price_button"
                        @click.stop="handleAddCart(couponBanner)"
                      >
                        <i class="icon iconfont icon-shopping"></i>
                        ${{ parseFloat(couponBanner.price).toFixed(2) }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@/assets/css/splide.min.css'
import { getCouponBanners, getCouponDetail } from '@/api/coupon'
import { mapMutations } from 'vuex'
export default {
  name: 'CanvasRebbin',
  components: {
    Splide,
    SplideSlide
  },
  data () {
    return {
      indent_style: '',
      validity_period: '05/01/2020 ~ 12/12/2020',
      coupons: [{ couponBannerUrl: '' }],
      cssBannerStyle: {
        url: require('@/assets/images/bg.svg')
      },
      wrapper: {
        url: require('@/assets/images/chop.svg')
      },
      options: {
        type: 'loop',
        speed: 800,
        width: 840,
        autoplay: true,
        interval: 5000,
        start: 0,
        drag: 'false',
        arrows: false
      },
      percentage: '50',
      couponBanners: [],
      couponBanner: {}
    }
  },
  computed: {},
  methods: {
    ...mapMutations('cart', [
      'addCart'
    ]),
    moved (splide) {
      // console.log( 'moved', newIndex );
      console.log('index', splide.index)
      console.log('banner', this.couponBanners[splide.index])
      this.couponBanner = {}
      this.couponBanner = this.couponBanners[splide.index]
    },
    hanldeCouponDetail (couponId) {
      this.$router.push({
        path: `/coupon/${couponId}`
      })
    },
    handleAddCart (couponBanner) {
      getCouponDetail(couponBanner.couponId).then(res => {
        this.addCart(res.data)
      })
    }
  },
  mounted () {
    getCouponBanners({
      pageNo: 0
    }).then((res) => {
      this.couponBanners = res.list
      this.couponBanner = this.couponBanners[0]
    })
  },
  destroyed () { }
}
</script>
<style scoped>
.couponBannerBox {
  position: relative;
  margin: 0px 0px;
}
.couponBannerBox .cssBanner {
  color: white;
  position: relative;
}

.coupon_leftContentBox {
  color: #ffffff;
  padding: 0 40px 0 0;
  position: relative;
  display: flex;
  align-items: center;
  text-align: left;
  transition-duration: 0.5s;
}
.coupon_leftContentBox_mainTitle {
  display: flex;
  flex-direction: column;
}

.coupon_leftContentBox_title {
  margin-bottom: 10px;
}

.coupon_leftContentBox_text {
  font-style: normal;
  font-weight: 300;
  font-size: 36px;
  line-height: 1.2;
  display: flex;
  height: 85px;
  justify-content: flex-start;
  align-items: center;
}

.couponBoxVerbar {
  width: 100%;
  border-bottom: 1px dotted #fff;
  margin: 12px 0 12px;
}
.couponBox_percentage {
  font-size: 4em;
  line-height: 1;
  font-weight: 800;
  vertical-align: top;
  display: inline-block;
}
.couponBox_smallText {
  display: inline-block;
  vertical-align: bottom;
  margin-left: 10px;
  padding-top: 10px;
}
.couponBox_smallText span {
  display: block;
  line-height: 1.3;
}
.coupon-promotion-info.row {
  margin: 0 -15px;
}

.coupon_redeem_button {
  width: 100%;
  height:48px;
  white-space: nowrap;
  margin-top: 10px;
  padding: 10px 15px;
  border: 0;
  font-size: 17px;
  color: #ffffff;
  background: #ffbf00;
  border-radius: 3px;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.coupon_redeem_button:hover {
  background: #d4517e;
}

.coupon_redeem_button:focus {
  outline: none;
}

.coupon_redeem_button .icon {
  margin-right: 5px;
  display: inline-block;
}

.coupon_swiperBox {
  position: relative;
  top: 50px;
  transition-duration: 0.5s;
  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.splide__slide {
  background: #fff;
}
.splide__slide img {
  width: 100%;
  object-fit: contain;
  height: 100%;
  max-height: 380px;
}

@media (max-width: 1650px) and (min-width: 1400px) {
  .coupon_swiperBox {
    right: 50px;
  }
}
@media (max-width: 1400px) and (min-width: 1025px) {
  /*.coupon_swiperBox {
    width: 740px;
    height: 0px;
    right: 0px;
  }*/
}

@media (max-width: 767px) {
  .coupon_rightContentBox {
    padding: 0;
    margin-bottom: 20px;
  }
  .coupon-promotion-info {
    padding: 0 0 20px 0;
  }
  .block {
    display: block;
    width: 100%;
  }

  .coupon_leftContentBox {
    padding: 0 20px;
    margin-top: 0px;
  }
  .coupon_leftContentBox_mainTitle {
    display: block;
  }
  .coupon_leftContentBox_text {
    font-size: 20px;
    height: 50px;
  }
  .coupon_leftContentBox_title {
    margin-bottom: 5px;
    font-size: 14px;
    display: block;
  }

  .coupon_leftContentBox_subtitle {
    position: relative;
  }
  .couponBox_percentage {
    font-size: 2.6rem;
  }
  .couponBox_smallText {
    display: inline-block;
    margin: 0;
    padding: 0 0 0 10px;
    font-size: 14px;
    line-height: 1.2;
  }
  .couponBox_smallText span {
    white-space: pre;
  }

  .coupon_redeem_button {
    padding: 5px 15px;
    margin-top: 5px;
    font-size: 16px;
  }

  .coupon_swiperBox {
    width: 100%;
    height: auto;
    position: relative;
    top: 0px;
    right: 0px;
  }

  .splide__pagination {
    position: absolute;
    z-index: 1;
    bottom: 0.5em !important;
    left: 14% !important;
    transform: translateX(-50%);
    padding: 0;
  }
}
@media screen and (max-width: 576px) {
  body {
    background-color: red;
  }
  ::v-deep .splide__pagination {
    left: 0 !important;
    transform: translateX(0%) !important;
  }
}

@media (min-width: 768px) and (max-width: 1280px) {
  .couponBox_percentage {
    font-size: 3em;
    vertical-align: top;
  }
  .coupon_leftContentBox_text {
    font-size: 20px;
    height: 45px;
  }
  .couponBox_smallText {
    font-size: 14px;
    margin-left: 0;
    line-height: 1.3;
    margin-left: 5px;
  }
  .coupon_redeem_button {
    padding: 5px 15px;
    margin-top: 10px;
  }
  .couponBannerBox .cssBanner {
    padding: 0 30px;
  }
  .coupon_swiperBox {
    top: 0px;
  }
  .coupon_leftContentBox {
    padding: 20px 0;
  }
  .splide__pagination__page {
    bottom: 15px !important;
  }
}

@media (min-width: 1280px) and (max-width: 1366px) {
  .coupon_leftContentBox {
    padding: 40px 0;
  }
  .coupon_leftContentBox_text {
    font-size: 30px;
    height: 70px;
  }
}
</style>
